import React from 'react';
import { Icon } from 'semantic-ui-react';
import './StudioPage.css';

export const StudioPage = ({ children, className = '', compact = false }) => (
  <div
    className={`studio-page${compact ? ' studio-page--compact' : ''}${
      className ? ` ${className}` : ''
    }`}
  >
    <div className='studio-page__content'>{children}</div>
  </div>
);

export const StudioHero = ({
  icon,
  kicker = 'AI STUDIO',
  title,
  description,
  children,
  className = '',
}) => (
  <section className={`studio-hero${className ? ` ${className}` : ''}`}>
    <div className='studio-hero__copy'>
      <div className='studio-hero__kicker'>
        {icon && (
          <span className='studio-hero__icon' aria-hidden='true'>
            <Icon name={icon} />
          </span>
        )}
        <span>{kicker}</span>
      </div>
      <h1>{title}</h1>
      {description && <p>{description}</p>}
    </div>
    {children && <div className='studio-hero__aside'>{children}</div>}
  </section>
);

export const StudioStat = ({ label, value, tone = 'neutral', icon }) => (
  <div className={`studio-stat studio-stat--${tone}`}>
    {icon && <Icon name={icon} className='studio-stat__icon' />}
    <span className='studio-stat__value'>{value}</span>
    <span className='studio-stat__label'>{label}</span>
  </div>
);

export const StudioFormHeader = ({
  icon,
  kicker = 'AI STUDIO',
  title,
  description,
}) => (
  <div className='studio-form-header'>
    <div className='studio-form-header__icon' aria-hidden='true'>
      <Icon name={icon || 'edit outline'} />
    </div>
    <div>
      <span>{kicker}</span>
      <h1>{title}</h1>
      {description && <p>{description}</p>}
    </div>
  </div>
);
